import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { PACKAGES } from "../../content";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToId } from "../../lib/api";

const Card = ({ p, onPick }) => (
  <motion.div
    whileHover={{ y: -10 }}
    transition={{ type: "spring", stiffness: 240, damping: 18 }}
    data-testid={`package-${p.id}`}
    className={`relative sticker rounded-[32px] p-8 h-full flex flex-col ${p.featured ? "bg-[var(--ink)] text-white lg:-translate-y-4" : "bg-white"}`}
  >
    {p.featured && (
      <span className="sticker-sm absolute -top-4 right-6 rotate-3 bg-[var(--sun)] text-[var(--ink)] rounded-full px-4 py-1 text-xs font-bold uppercase tracking-widest">
        Most booked
      </span>
    )}
    <span className="w-12 h-3 rounded-full" style={{ background: p.color }} />
    <h3 className="font-display font-bold text-3xl mt-5">{p.name}</h3>
    <p className={`mt-1 ${p.featured ? "text-white/80" : "text-[var(--ink-soft)]"}`}>{p.tagline}</p>
    <p data-testid={`package-${p.id}-price`} className="font-display font-bold text-6xl mt-8">{p.price}</p>
    <ul className="mt-8 space-y-3 flex-1">
      {p.features.map((f) => (
        <li key={f} className="flex gap-3 items-start">
          <span className="mt-0.5 w-6 h-6 shrink-0 rounded-full grid place-items-center" style={{ background: p.color }}>
            <Check size={14} strokeWidth={3} className="text-white" />
          </span>
          <span className="font-medium">{f}</span>
        </li>
      ))}
    </ul>
    <motion.button
      whileTap={{ scale: 0.96 }}
      data-testid={`package-${p.id}-select-btn`}
      onClick={() => onPick(p.name)}
      className={`mt-10 sticker-sm rounded-full py-3.5 font-display font-semibold text-lg ${p.featured ? "bg-[var(--coral)] text-white" : "bg-[var(--cream)]"}`}
    >
      Pick this one
    </motion.button>
  </motion.div>
);

export const Packages = ({ onPick }) => {
  const pick = (name) => {
    onPick(name);
    scrollToId("book");
  };
  return (
    <section id="packages" data-testid="packages-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-left max-w-2xl">
          <Eyebrow color="var(--grass)">Packages</Eyebrow>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[0.95]">
            Small, grand or <span className="text-[var(--coral)]">ultimate.</span>
          </h2>
          <p className="mt-5 text-[var(--ink-soft)] text-base sm:text-lg">Every package includes setup by the kids and pick-up the next day.</p>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-3 gap-8 items-stretch">
          {PACKAGES.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.1}>
              <Card p={p} onPick={pick} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
